require('./bootstrap');
import Vue from 'vue';
import VueRouter from 'vue-router';
import store from './store';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Icon from '@components/Icon';
import VueLazyLoad from 'vue-lazyload';
import VTooltip from 'v-tooltip';
import VModal from 'vue-js-modal';
import VCalendar from 'v-calendar';
import VueLazyload from 'vue-lazyload';
import VueGtag from 'vue-gtag';
import VueYouTubeEmbed from 'vue-youtube-embed';
import {
  faSquareXTwitter,
  faLinkedin,
  faFacebookSquare,
  faInstagram,
  faYoutubeSquare,
} from '@fortawesome/free-brands-svg-icons';

window.axios.defaults.headers.common['app-location'] = 'frontend';

library.add(faSquareXTwitter, faLinkedin, faFacebookSquare, faInstagram, faYoutubeSquare);

let VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo, {
  container: '#page',
  duration: 1000,
  easing: 'ease-out-in',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
});

Vue.use(VueLazyload, {
  observer: true,
  preLoad: 3,
});

Vue.use(VTooltip);
Vue.use(VueRouter);
Vue.use(VueLazyLoad);
Vue.use(VModal);
Vue.use(VCalendar);
Vue.use(VueYouTubeEmbed);

import routes from './routes/app';

Vue.component('client', require('./pages/Client.vue').default);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('icon', Icon);

import goto from './mixins/goto';
import date from './mixins/formatter';
import calc from './mixins/calculateWidth';
import { addBackgroundVideoListeners } from './utils/video';

Vue.mixin(goto);
Vue.mixin(date);
Vue.mixin(calc);

const router = new VueRouter({
  routes,
  mode: 'history',
});

Vue.use(VueGtag, { config: { id: 'G-RJRVGJS511' } }, router);

Vue.prototype.$bus = new Vue();
const app = new Vue({
  el: '#app',
  router,
  store,
});

addBackgroundVideoListeners();
